<template>
    <section class="section login-page">
        <div class="container">
            <div class="columns is-centered">
                <div class="column has-text-centered">
                    <img class="logo" src="@/assets/logo.png" alt="Daily Fruits Delivery App">
                    <br /><br /><br />
                    <h1 class="title">DailyFruits</h1>
                    <h2 class="subtitle">{{ title }}</h2>
                </div>
            </div>
            <div class="columns is-mobile is-centered">
                <div class="column is-10">
                  <form @submit.prevent="handleLoginFormSubmit">
                      <div class="field">
                          <label class="label">e-mail</label>
                          <p class="control">
                              <input
                                  class="input is-medium"
                                  type="email"
                                  placeholder="e-mail"
                                  v-model="login.email"
                              >
                          </p>
                      </div>
                      <div class="field">
                          <label class="label">Hasło</label>
                          <p class="control">
                              <input
                                  class="input is-medium"
                                  type="password"
                                  placeholder="hasło"
                                  v-model="login.password"
                              >
                          </p>
                      </div>
                      <div class="field">
                          <p class="control has-text-centered">
                              <br><br><br>
                              <button class="button is-primary is-large" :class="{ 'button--loading': isLogging }">
                                  <span>Zaloguj</span>
                                  <span class="icon button__icon">
                                      <svg-icon type="loader" />
                                  </span>
                              </button>
                          </p>
                      </div>
                  </form>
                  <br />
                  <p class="has-text-centered">
                      v{{ version }}
                  </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios'
import localforage from 'localforage'
import SvgIcon from '@/components/SvgIcon'

export default {
    components: {
        'svg-icon': SvgIcon
    },
    data() {
        return {
            isLogging: false,
            login: {
                email: (process.env.NODE_ENV !== 'production' && process.env.VUE_APP_EMAIL) ?
                    process.env.VUE_APP_EMAIL :
                    '',
                password: (process.env.NODE_ENV !== 'production' && process.env.VUE_APP_PASS) ?
                    process.env.VUE_APP_PASS :
                    ''
            },
            title: process.env.VUE_APP_MODE === 'production' ? 'Delivery App' : `Delivery App [${process.env.VUE_APP_MODE.toUpperCase()}]`
        }
    },
    computed: {
        version() {
            return process.env.PACKAGE_VERSION
        }
    },
    methods: {
        handleLoginFormSubmit(){
            this.isLogging = true
            const postData ={
                email: this.login.email,
                password_hash: this.login.password
            }
            axios.post(process.env.VUE_APP_API+'users', postData)
            .then(response => {
                if(response.status === 200){
                    if(response.data.data.checkDistance){
                        localforage.setItem('checkDistance', response.data.data.checkDistance)
                    }else{
                        localforage.setItem('checkDistance', 0)
                    }
                    if(response.data.data.access_token){
                        const headers = {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + response.data.data.access_token
                        }
                        localforage.setItem('authUser', JSON.stringify(headers)).then(() => {
                            this.isLogging = false
                            this.$router.push({name: 'deliveries'})
                        })
                    }
                } else {
                    this.$store.dispatch('addNotification', {
                        type: 'danger',
                        title: 'Błąd logowania',
                        content: `Błędna odpowiedź serwera: ${response.status}`
                    })
                }
            })
            .catch(error => {
                this.isLogging = false
                if(error.response && error.response.status === 401){
                    this.$store.dispatch('addNotification', {
                        type: 'danger',
                        title: 'Błąd logowania',
                        content: 'Podano błędny email lub hasło'
                    })
                } else {
                    if(navigator.onLine === false){
                        this.$store.dispatch('addNotification', {
                            type: 'danger',
                            title: 'Błąd logowania',
                            content: 'Brak połączenia z internetem'
                        })
                    } else {
                        this.$store.dispatch('addNotification', {
                            type: 'danger',
                            title: 'Błąd logowania',
                            content: `Błędna odpowiedź serwera: ${error}`
                        })
                    }
                }
            })
        }
    }
}
</script>

<style scoped lang="sass">
@import "@/styles/variables"
.title
    font-weight: 300
    color: $green
    font-size: $size-2
.subtitle
    font-weight: 600
    color: $text
.button
    padding-left: 5rem
    padding-right: 5rem
</style>
